import React from "react";
import VisibilitySensor from "react-visibility-sensor";

import constants from "../assets/js/constants";
import { getVisibleSensorAnimation } from "../assets/js/utils";

function HorizontalBar({
  widthPercentage = "100%",
  color = "white",
  backgroundColor = constants.COLORS.PRIMARY,
  value,
  position,
}) {
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div
          className="horizontal-bar"
          style={{
            backgroundColor,
            color,
            width: widthPercentage,
            ...getVisibleSensorAnimation(
              isVisible,
              `width-increase-2 ${2 + position * 0.5}s  backwards`
            ),
          }}
        >
          <span
            className="horizontal-bar__value"
            style={getVisibleSensorAnimation(isVisible, "appear 2s")}
          >
            {value}
          </span>
        </div>
      )}
    </VisibilitySensor>
  );
}

export default HorizontalBar;
